import { ClientInteractionViewModel } from '../clientInteractionViewModel';

export class ClientInteractionCreatedEvent {
  get type() {
    return ClientInteractionCreatedEvent.type;
  }
  static type = 'ClientInteractionCreated';
  constructor(readonly payload: ClientInteractionViewModel) {}
}
